import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrderService {

    constructor(private http: HttpClient) {

    }

    // Add order
    add(order: any) {
        return this.http.post<any>(`${environment.baseUrl}/order`, order).pipe(
            map(response => response)
        );
    }
    //Add report
    create(order: any) {
        return this.http.post<any>(`${environment.baseUrl}/report/add`, order).pipe(
            map(response => response)
        );
    }
    // Update order
    update(order: any) {
        return this.http.put<any>(`${environment.baseUrl}/order`, order).pipe(
            map(response => response)
        );
    }

    // Upload image
    testUploadFile(data: any) {
        return this.http.post<any>(`${environment.baseUrl}/file/upload`, data , {
            reportProgress: true,
            observe: 'events'
        }).pipe(
            map(response => response)
        );
    }

    // Get all technician for assign technician in the dropdown
    getAllTechnician(filter: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/isp/technicians`, filter)
        .pipe(
            map( res => res)
        );
    }
    getreport(filter: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/report`, filter)
        .pipe(
            map( res => res)
        );
    }
    // Get all ISP's for assign isp's
    getAllIsps(filter: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/admin/isp`, filter)
        .pipe(
            map( res => res)
        );
    }

    // Get order details by order id
    getByOrderID(orderId): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}/order/${orderId}`)
        .pipe(
            map( res => res)
        );
    }

    // Get all order list
    getAllOrders(filter: any) {
        return this.http.post<any>(`${environment.baseUrl}/orders`, filter).pipe(
            map( res => res)
        );
    }

    // getting data for dashboard
    getDataCountsForDashboard(filters: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/orders/count`, filters)
        .pipe(
            map( res => res)
        );
    }

    // getting order by id
    getOrderById(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/orders-associated`, data)
        .pipe(
            map( res => res)
        );
    }

    // check order is present or not
    orderCheck(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/order-check`, data)
        .pipe(
            map( res => res)
        );
    }

    // Search Order by order id
    searchOrder(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/isp-order/search`, data)
        .pipe(
            map( res => res)
        );
    }

    // Save order Timeline massage by id
    saveOrderMessage(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/order/message`, data)
        .pipe(
            map( res => res)
        );
    }

    // Get timeline massage by order id
    getOrderMessage(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/order/messages`, data)
        .pipe(
            map( res => res)
        );
    }

    // Get All Dropdowns for add orders
    getAllDropdown(): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/utility/dropdowns`, {});
    }

    // Get Order Status Whether Accept or Reject
    getOrderAcceptOrReject(postData: any) {
        return this.http.post<any>(`${environment.baseUrl}/order/accept-reject`, postData);
    }

    //save tech-allocation
    saveTechAllocation(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/order/tech-allocation`, data)
        .pipe(
            map( res => res)
        );
    }
   
     //save tech-allocation
     getAllBrands(): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}/utility/barnds`)
        .pipe(
            map( res => res)
        );
    }

    //get-all tech-allocation
    getAllTechAllocation(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/order/tech-allocation/get-by-status`,data)
        .pipe(
            map( res => res)
        );
    }

    getmisOrders(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/mis/order`,data)
        .pipe(
            map( res => res)
        );
    }
    
    getOrdersAttachments(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/mis/order-attachments`,data, {responseType:'blob' as 'json'})
        .pipe(
            map( res => res)
        );
    }

    getmisOrderExport(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/mis/order-attachment-excel`,data, {responseType:'blob' as 'json'})
        .pipe(
            map( res => res)
        );
    }

    closeOrder(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/close-order`,data)
        .pipe(
            map( res => res)
        );
    }


    getHierarchyReport(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/hierarchy-report-excel`,data, {responseType:'blob' as 'json'})
        .pipe(
            map( res => res)
        );
    }
}